var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRipple(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 103,
    cy: 103,
    r: 14,
    fill: "#00FFFF",
    opacity: 0.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 103,
    cy: 103,
    r: 36,
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 2,
    opacity: 0.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 103,
    cy: 103,
    r: 58,
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 2,
    opacity: 0.45
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 103,
    cy: 103,
    r: 80,
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 2,
    opacity: 0.4
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 97,
    cy: 97,
    r: 14,
    fill: "#FF00FF",
    opacity: 0.45
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 97,
    cy: 97,
    r: 36,
    fill: "none",
    stroke: "#FF00FF",
    strokeWidth: 2,
    opacity: 0.4
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 97,
    cy: 97,
    r: 58,
    fill: "none",
    stroke: "#FF00FF",
    strokeWidth: 2,
    opacity: 0.35
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 97,
    cy: 97,
    r: 80,
    fill: "none",
    stroke: "#FF00FF",
    strokeWidth: 2,
    opacity: 0.3
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 14,
    fill: "white",
    stroke: "#CC00CC",
    strokeWidth: 4
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 36,
    fill: "none",
    stroke: "#CC00CC",
    strokeWidth: 4
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 58,
    fill: "none",
    stroke: "#CC00CC",
    strokeWidth: 3.5
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 80,
    fill: "none",
    stroke: "#CC00CC",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 20 A80 80 0 1 1 99 20",
    fill: "none",
    stroke: "white",
    strokeWidth: 5,
    strokeDasharray: "18,0",
    strokeDashoffset: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRipple);
export default __webpack_public_path__ + "static/media/ripple.cd8a7be24161a5c9504992a010e3dec1.svg";
export { ForwardRef as ReactComponent };